import MainPage from "./pages/MainPage/MainPage";
import ConfigPanel from "./pages/ConfigPanelPage/ConfigPanel";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { useState } from "react";

const useApp = () => {
  const [path, handlePath] = useState(window.location.pathname);

  return { path, handlePath };
};

const App = () => {
  const { path, handlePath } = useApp();
  console.log(path);

  if (path.includes("/nps")) return <MainPage handlePath={handlePath} />;
  if (path.includes("/painel")) return <ConfigPanel handlePath={handlePath} />;

  return <MainPage />;
};

export default App;
